import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
import { useUnitsFormatter } from "hooks/formatters";
import { HeatMix, SummaryData } from "src/store/api/generatedApi";
import { useNumberSerialiser } from "hooks/serialisers/numbers";
import { ValueWithDiff } from "../ValueWithDiff";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const HeatMixImportantValues = ({
  stageMix,
  isFirst = false,
}: {
  stageMix: HeatMix;
  isFirst?: boolean;
}) => {
  const { t } = useTranslation();
  const units = useUnitsFormatter(true);
  const { format } = useNumberSerialiser();

  const { summary_data: summaries } = stageMix;

  const sortedSummaries = useMemo(
    () => [...summaries].sort((a, b) => a.name.localeCompare(b.name)),
    [summaries]
  );

  const formatMetricName = (summary: SummaryData) =>
    summary.unit_type === null
      ? t(summary.name)
      : `${t(summary.name)}${units(summary.unit_type)}`;

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Table size="small" sx={{ overflow: "hidden" }}>
        <TableBody>
          {sortedSummaries.map((summary) => (
            <TableRow key={summary.name}>
              {isFirst ? (
                <TableCell sx={{ pr: 0 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    {formatMetricName(summary)}
                  </Typography>
                </TableCell>
              ) : null}
              <TableCell align="center">
                <ValueWithDiff
                  summary={summary}
                  formatNumber={format}
                  hideDiff={isFirst}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
